{
  "title": "參賽者總表欄位參考",
  "description": "「參賽者」頁的欄位定義與可用篩選條件，快速查閱各欄位代表的意義。",
  "headings": ["欄位說明", "可用篩選條件"],
  "intro": "「資料」分組下的「參賽者」頁提供全競賽層級的參賽者總表，只包含實際參賽者（隊長與隊員），與「人員與角色」頁所管理的工作人員、管理員、評審等治理角色分開，兩頁的資料來源與用途不同，請勿混淆。",
  "submissionSectionHeading": "欄位說明",
  "submissionStatuses": [
    { "name": "姓名／Email", "editable": "參賽者顯示名稱與註冊 Email，兩者顯示於同一欄。" },
    { "name": "隊伍", "editable": "該參賽者所屬隊伍名稱。" },
    { "name": "隊伍角色", "editable": "在隊伍中的角色，隊長或隊員。" },
    { "name": "類別", "editable": "該參賽者所屬隊伍報名的競賽組別。" },
    { "name": "學校", "editable": "參賽者填寫的學校名稱；未填寫時顯示「未設定」。" },
    { "name": "系所", "editable": "參賽者填寫的系所名稱；未填寫時顯示「未設定」。" },
    {
      "name": "資格驗證狀態",
      "editable": "與「隊伍與人員」資格驗證分頁完全相同的狀態徽章（已通過／待審核／已退回／缺件／已過期）。"
    },
    {
      "name": "報名狀態",
      "editable": "該參賽者的報名表填寫完成度，僅「已完成」或「未完成」兩種，與資格驗證狀態完全無關的獨立判定。"
    },
    { "name": "最後更新時間", "editable": "該筆參賽者資料最後一次異動的時間。" }
  ],
  "judgeSectionHeading": "可用篩選條件",
  "judgeStatuses": [
    { "name": "依隊伍篩選", "description": "從下拉選單選擇特定隊伍，只顯示該隊伍的參賽者。" },
    { "name": "依類別篩選", "description": "只顯示指定競賽組別的參賽者。" },
    { "name": "依資格驗證狀態篩選", "description": "只顯示指定資格驗證狀態的參賽者。" },
    { "name": "依報名狀態篩選", "description": "只顯示報名「已完成」或「未完成」的參賽者。" },
    {
      "name": "依姓名／Email／學校搜尋",
      "description": "文字搜尋框，同時比對姓名、Email、學校三個欄位。"
    },
    {
      "name": "排序",
      "description": "可依姓名或最後更新時間排序清單，篩選與排序條件皆會保留在網址列，方便分享或重新整理後仍維持原本的查詢結果。"
    }
  ]
}
